// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const GroupSingle = () => {
//   // Extracting groupId using regular expressions
//   const location = useLocation();
//   // const groupId = location.pathname.match(/\/class\/(\d+)/);
//   const groupId = location.pathname.match(/\/group\/(\d+)/)?.[1];

//   const [group, setGroup] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/group/${groupId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setGroup(data);
//       localStorage.setItem("dutyData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (groupId) {
//       fetchClass();
//     }
//   }, [groupId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Group Details</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{group?.data.name}</h1>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{group?.data.id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{group?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Subjects: </span>
//                     <span className="itemValue">
//                       {group?.data.subject_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Batch: </span>
//                     <span className="itemValue">{group?.data.batch_names}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">{group?.data.class_names}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Group Name: </span>
//                                             <span className="itemValue">{group?.data.name}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{group?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default GroupSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const GroupSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const groupId = location.pathname.match(/\/group\/(\d+)/)?.[1];
  const [group, setGroup] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchGroup = async () => {
    try {
      const response = await fetch(`${serverUrl}/group/${groupId}`);
      const data = await response.json();
      setGroup(data);
      localStorage.setItem("groupData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchGroup();
    }
  }, [groupId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Group Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Group Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Group Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Group Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {group?.data.name}
                      </h1>
                    </div>
                  </div>
                </div>

                {/* Group Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Group Details
                  </h3>

                  <div className="grid grid-cols-1 gap-6">
                    {/* Subjects - Full width on mobile */}
                    {group?.data.subject_names && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Subjects
                        </label>
                        <div className="bg-gray-50 rounded-lg p-4">
                          <p className="text-gray-800 break-words whitespace-normal">
                            {group.data.subject_names}
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Batch */}
                      {group?.data.batch_names && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Batch
                          </label>
                          <div className="bg-gray-50 rounded-lg p-4">
                            <p className="text-gray-800 break-words whitespace-normal">
                              {group.data.batch_names}
                            </p>
                          </div>
                        </div>
                      )}

                      {/* Class */}
                      {group?.data.class_names && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Class
                          </label>
                          <div className="bg-gray-50 rounded-lg p-4">
                            <p className="text-gray-800 break-words whitespace-normal">
                              {group.data.class_names}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupSingle;
